import * as Fa from "react-icons/fa";
import { FileUpload } from "primereact/fileupload";
import { toast } from "react-toastify";
import { fetchData } from "../../../Services/GlobalService";
import { useEffect, useRef, useState } from "react";
import Loader from "../../../Components/Loader";
import * as XLSX from "xlsx";
import { GetDateFormat } from "../../../Services/GlobalFunction/GetDateFormat";
import { ExtractExcelFileData } from "../../../Services/GlobalFunction/ExcelFileData";
import { AxiosExcel } from "../../../API/Axios";
import {
  ExcelTemplateDownload,
  ExcelUpload,
} from "../../../Services/GlobalFunction/Excel";
import {
  downloadExcel,
  downloadExcelDateFormat,
} from "../../../Services/GlobalFunction/DownLoadExcel";
import { Dropdown } from "primereact/dropdown";
import Product from "./Product/Product";
import { downloadCSV } from "../../../Services/GlobalFunction/DownLoadCSV";

const SKUDivisor = () => {
  const [loader, setLoader] = useState(false);
  const [errorxlsbtn, setErrorxlsbtn] = useState(false);
  const [errorxlsData, setErrorxlsData] = useState([]);
  const [fileType, setFileType] = useState("xlsx");
  const UserId = localStorage.getItem("UserId")?.toString();
  let getformat = GetDateFormat();
  let uniqueNo = `SKU_Divisor_${getformat}`;
  const BaseURl = "SkuDivisor";
  const EndPoint = {
    GetAllSKUData: "GetExportData",
  };
  const FileType = ["csv", "xlsx"];
  const fileUploadRef = useRef<FileUpload>(null);
  const GetAllSKUData = async () => {
    setLoader(true);
    try {
      await fetchData(
        BaseURl,
        EndPoint.GetAllSKUData,
        `PVCUSERID=${UserId}`,
      ).then((res) => {
        console.log(res.Data, "skuDivisorData");
        if (res.Data.length > 0) {
          // if (fileType === "xlsx") {
          //   downloadExcelDateFormat(
          //     res.Data,
          //     `SKU_Divisor_${GetDateFormat()}.xlsx`,
          //   );
          // }
          //  else if (fileType === "csv") {
          downloadExcelDateFormat(
            res.Data,
            `SKU_Divisor_${GetDateFormat()}.csv`,
          );
          // } else {
          //   toast.warn("Please select file type");
          // }
        } else {
          toast.error("No Data Found");
        }
        setLoader(false);
      });
    } catch (ex: any) {
      toast.error(ex?.response?.data?.Message);
      setLoader(false);
    }
  };
  const handleFileUpload = async (event: any) => {
    try {
      setLoader(true);
      let res = await ExcelUpload(
        "SKU_DIVISOR_CONFIG",
        "",
        event.files[0],
        "CSV",
      );
      console.log(res, "SKUDivisorUpload");
      if (res.Status == "Success") {
        toast.success(res.Message);
        fileUploadRef.current?.clear();
        setErrorxlsbtn(false);
      } else if (res.Status == "ErrorFR") {
        toast.warn(res.Message);
        fileUploadRef.current?.clear();
        setErrorxlsbtn(false);
      } else if (res.Status == "Error") {
        toast.warn(res.Message);
        setErrorxlsbtn(true);
        setErrorxlsData(res.Data);
      }
      setLoader(false);
    } catch (ex: any) {
      toast.error(ex?.response?.data?.Message);
      fileUploadRef.current?.clear();
      setErrorxlsbtn(false);
      setLoader(false);
    }
  };
  const getExcelTemplate = async () => {
    setLoader(true);
    try {
      await ExcelTemplateDownload("SKU_DIVISOR_CONFIG").then((res) => {
        setLoader(false);
        // if (fileType === "csv") {
        downloadCSV(res, `SKU_Divisor_Map_Template_${GetDateFormat()}.csv`);
        // } else if (fileType === "xlsx") {
        //   downloadExcel(res, `SKU_Divisor_Map_Template_${GetDateFormat()}.xlsx`);
        // }
      });
    } catch (error: any) {
      setLoader(false);
      toast.warn(error.message);
    }
  };
  const excelErrorDownload = () => {
    setLoader(true);
    downloadExcel(errorxlsData, "SKU_Error.xlsx");
    setLoader(false);
  };
  if (loader) {
    return <Loader />;
  } else {
    return (
      <main>
        <div className="col-12 mb-5">
          {/* Breadcrumb  */}
          <div className="col-lg-12 col-md-12 col-sm-12">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mx-0">
                <li className="breadcrumb-item">Masters</li>
                <li className="breadcrumb-item" aria-current="page">
                  Product
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  SKU Divisor Mapping
                </li>
              </ol>
            </nav>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <h3 className="py-2">SKU Divisor Mapping</h3>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="float-end mb-2">
                <div className="display-b me-2">
                  {/* <Dropdown
                    placeholder="File Type"
                    value={fileType}
                    options={FileType}
                    onChange={(e: any) => {
                      setFileType(e.value);
                      console.log(e.value, "FileType");
                    }}
                  /> */}
                </div>
                <button
                  type="button"
                  title="Download Template"
                  className="btn anime-btn me-2"
                  onClick={() => getExcelTemplate()}
                >
                  Download Template <Fa.FaDownload className="ms-2" />
                </button>
                <button
                  type="submit"
                  title="Export"
                  className="btn anime-btn me-2"
                  onClick={GetAllSKUData}
                >
                  {" "}
                  Export <Fa.FaFileExport className="ms-2" />
                </button>
                {errorxlsbtn && (
                  <button
                    type="button"
                    title="Error Excel File"
                    className="btn anime-red-btn ml-2"
                    onClick={excelErrorDownload}
                  >
                    {" "}
                    Error Excel File <Fa.FaDownload className="ms-2" />
                  </button>
                )}
              </div>
            </div>
          </div>

          <section className="sales-box">
            <div className="row d-flex justify-content-center align-items-center">
              <div className="col-lg-8 col-md-12 col-sm-12 clearfix">
                <div className="UploadSection clearfix">
                  <div className="conText">
                    {" "}
                    <Fa.FaInfoCircle className="icon" /> Select an CSV File to
                    upload
                  </div>
                  <FileUpload
                    ref={fileUploadRef}
                    className="clearfix nTopMargin"
                    name="demo[]"
                    accept=".csv"
                    // maxFileSize={1000000}
                    emptyTemplate={
                      <p className="m-0">
                        Drag and drop files to here to upload.
                      </p>
                    }
                    customUpload
                    uploadHandler={handleFileUpload}
                    onClear={() => {
                      setErrorxlsbtn(false);
                    }}
                    onRemove={() => {
                      setErrorxlsbtn(false);
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12">
                <div className="text-end">
                  <img
                    src={require("../../../Assets/Images/File_Upload.png")}
                    className="File_Upload_Img drop-right"
                  />
                </div>
              </div>
            </div>
            <small className="text-success my-2">
              <i>
                <b>*Note:</b> In the Activity column, use <b>N</b> to add a new
                record, <b>U</b> to update an existing one, and <b>D</b> to
                delete a record
              </i>
            </small>
          </section>
        </div>
      </main>
    );
  }
};

export default SKUDivisor;
